/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

export const NavigationMenuContext = createContext( {
	menu: undefined,
	search: '',
} );
export const useNavigationMenuContext = () =>
	useContext( NavigationMenuContext );
